
import React from "react";
import { 
  Card, 
  CardContent, 
  CardHeader, 
  CardTitle, 
  CardDescription 
} from "@/components/ui/card";
import { Globe } from "lucide-react";
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend, 
  ResponsiveContainer,
  Cell
} from "recharts";

// Country distribution colors
const COUNTRY_COLORS = [
  "#3498db", "#9b59b6", "#2ecc71", "#f1c40f", "#e74c3c", 
  "#1abc9c", "#34495e", "#95a5a6", "#d35400", "#c0392b"
];

interface CountryDistributionChartProps {
  countryDistribution: {
    country: string;
    count: number;
  }[];
}

const CountryDistributionChart = ({ countryDistribution }: CountryDistributionChartProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Globe className="mr-2 h-5 w-5 text-[#333B44]" />
          Country Distribution
        </CardTitle>
        <CardDescription>
          User countries of origin
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={countryDistribution}
              layout="vertical"
              margin={{
                top: 20,
                right: 30,
                left: 80,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" tickFormatter={(value) => Math.round(value).toString()} />
              <YAxis dataKey="country" type="category" width={80} />
              <Tooltip formatter={(value) => [Math.round(Number(value)), ""]} />
              <Legend verticalAlign="top" height={36} formatter={(value) => value} />
              <Bar dataKey="count" name="Users">
                {countryDistribution.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COUNTRY_COLORS[index % COUNTRY_COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default CountryDistributionChart;
